import { Box, Container, Typography } from "@mui/material";

import { AMP, CTDNA, DNA, RNA } from "components/acronyms";
import { MutationList } from "components/MutationList";
import { colors } from "theme";

export const DetailInfo = () => (
  <Box
    component="section"
    bgcolor={colors.white}
    pt={{ xs: 3, sm: 4, md: 5, lg: 10 }}
    pb={{ xs: 4, sm: 2.5, md: 7 }}
  >
    <Container>
      <Box mb={{ xs: 2, sm: 3, md: 4, lg: 2.25 }}>
        <Typography variant="h3" component="h2" align="center">
          Our <AMP />
          -based platform enables any molecular lab to generate high-quality
          sequencing results to turn liquid and tissue biopsies into powerful
          genomic insights by combining proprietary chemistry, a streamlined
          workflow and powerful analytics.
        </Typography>
      </Box>
      <Box
        width={{ xs: "unset", sm: "unset", md: 759 }}
        margin="auto"
        mb={{ xs: 7, sm: 6, md: 5 }}
      >
        <Typography variant="subtitle1" component="p" align="center">
          Our suite of <AMP />
          -based research products include{" "}
          <Box component="span" fontWeight={600}>
            FusionPlex<sup>®</sup>
          </Box>{" "}
          for <RNA />
          -based sequencing,{" "}
          <Box component="span" fontWeight={600}>
            VariantPlex<sup>®</sup>
          </Box>{" "}
          for <DNA />
          -based sequencing,{" "}
          <Box component="span" fontWeight={600}>
            LiquidPlex<sup>™</sup>
          </Box>{" "}
          for <CTDNA /> sequencing, and{" "}
          <Box component="span" fontWeight={600}>
            Immunoverse<sup>™</sup>
          </Box>{" "}
          to characterize the human immune repertoire from <RNA /> input.
          Together, Our kitted oncology solutions provide robust
          detection capabilities for all mutation types to fuel your cancer
          research.
        </Typography>
      </Box>
      <MutationList />
    </Container>
  </Box>
);
